export enum DeliveryType {
  KITOPI_DELIVERY = 'KITOPI_OWN_DELIVERY',
  AGGREGATOR_DELIVERY = 'PARTNER_DELIVERY',
  DEFAULT = 'DEFAULT',
}
